"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/es6.object.keys");require("core-js/modules/web.dom.iterable");

























































var _formatter = require("@/utils/formatter"); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { data: function data() {return { searchData: { page: 1, rows: 10, nickName: '' }, //列表筛选参数
      pageData: { page: 1, rows: 10, total: 0, pages: 1 }, //分页数据
      tableData: [], //表格数据
      tableColumn: [{ label: '服务器地址', prop: 'smtpServer' }, { label: '服务器端口', prop: 'smtpPort' }, { label: '邮箱账号', prop: 'account' }, { label: '发件人昵称', prop: 'nickName' }, { label: '创建时间', prop: 'createTime', formatter: _formatter.dateFormatter }, { label: '更新时间', prop: 'updateTime', formatter: _formatter.dateFormatter }], //表头数据
      showAdd: false, //是否显示新增||编辑弹窗
      configForm: { id: '', smtpServer: '', smtpPort: '', account: '', password: '', nickName: '' }, //新增||编辑表单
      editRow: '', configFormRule: { smtpServer: [{ required: true, message: '请填写服务器地址', trigger: ['change', 'blur'] }], account: [{ required: true, message: '请填写邮箱账号', trigger: ['change', 'blur'] }],

        password: [{
          required: true,
          message: '请填写密码',
          trigger: ['change', 'blur'] }],

        nickName: [{
          required: true,
          message: '请填写发件人昵称',
          trigger: ['change', 'blur'] }] }

      //表单校验规则
    };
  },

  mounted: function mounted() {
    this.fetchList();
  },

  methods: {
    /**
              * 发件人列表
              */
    fetchList: function fetchList() {var _this = this;
      var params = Object.assign({}, this.searchData);
      this.getData('/api/mailSender/getAll', params, function (res) {
        _this.tableData = res.list;
        _this.pageData.page = res.pageNum;
        _this.pageData.total = res.total;
      });
    },

    /**
        * 重置
        */
    onClickReset: function onClickReset() {
      this.$set(this.searchData, 'nickName', '');
      this.$set(this.searchData, 'page', 1);
      this.fetchList();
    },

    /**
        * size-change
        */
    handleSizeChange: function handleSizeChange(val) {
      this.$set(this.searchData, 'page', 1);
      this.$set(this.searchData, 'rows', val);
      this.fetchList();
    },

    /**
        * Page-change
        */
    handleCurrentChange: function handleCurrentChange(val) {
      this.$set(this.searchData, 'page', val);
      this.fetchList();
    },

    /**
        * 编辑
        */
    editItem: function editItem(row) {
      this.showAdd = true;
      this.editRow = Object.assign({}, row);
      this.$set(this.configForm, 'id', row.id);
      this.$set(this.configForm, 'smtpServer', row.smtpServer);
      this.$set(this.configForm, 'smtpPort', row.smtpPort + '');
      this.$set(this.configForm, 'account', row.account);
      this.$set(this.configForm, 'password', row.password);
      this.$set(this.configForm, 'nickName', row.nickName);
    },

    /**
        * 删除
        */
    delItem: function delItem(row) {var _this2 = this;
      this.$confirm('确定删除当前邮件发件人配置？', '提示', { type: 'warning' }).then(function (res) {
        //删除通知
        _this2.delData("/api/mailSender/delete/".concat(row.id), {}, function (res) {
          _this2.fetchList();
        });
      }).catch(function (err) {

      });
    },

    /**
        * 弹窗打开
        */
    onAddDialogOpen: function onAddDialogOpen() {var _this3 = this;
      this.$nextTick(function () {
        _this3.$refs.configForm.clearValidate();
      });
    },

    /**
        * 新增||编辑弹窗关闭
        */
    onAddDialogClose: function onAddDialogClose() {var _this4 = this;
      this.$nextTick(function () {
        Object.keys(_this4.configForm).forEach(function (e) {
          _this4.$set(_this4.configForm, e, '');
        });
        _this4.$refs.configForm.clearValidate();
        _this4.editRow = '';
      });
      this.showAdd = false;
    },

    /**
        * 保存
        */
    onSaveConfig: function onSaveConfig() {var _this5 = this;
      this.$refs.configForm.validate(function (valid) {
        if (valid) {
          var params = Object.assign({}, _this5.configForm);
          if (params.id) {
            //编辑
            params.delFlag = _this5.editRow.delFlag;
            params.createTime = _this5.editRow.createTime;
            _this5.putData('/api/mailSender/update', params, function (res) {
              _this5.onAddDialogClose();
              _this5.fetchList();
            });
          } else {
            //新增
            delete params['id'];
            _this5.postData('/api/mailSender/insert', params, function (res) {
              _this5.$set(_this5.searchData, 'page', 1);
              _this5.onAddDialogClose();
              _this5.fetchList();
            });
          }
        }
      });
    } } };exports.default = _default;